module.exports = __webpack_public_path__ + "static/media/undo-alt.07dbda5e.svg";